<template>
  <div id="supplier">
    <div class="card">
      <h2>Modelle</h2>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-6">
          <Dropdown
            @change="updateReps"
            :filter="true"
            v-model="selectedSupplier"
            :options="allSuppliers"
            optionLabel="name"
            placeholder="Lieferanten auswählen"
          />
        </div>
      </div>
      <div class="p-fluid p-grid">
        <div class="p-field p-col-12">
          <div class="p-field-checkbox">
            <Checkbox
              v-model="freeCollection"
              value="all"
              id="freeCollection"
              inputId="freeCollectionCbx"
              name="freeCollection"
            />
            <label for="freeCollection">Alle Modelle</label>
          </div>
        </div>
      </div>
    </div>

    <div v-if="showList">
      <DataTable
        :value="representatives"
        :paginator="true"
        class="p-datatable-products"
        :rows="10"
        data-key="id"
        :filters="filters"
        :loading="loading"
      >
        <template #header>
          <div class="table-header">
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <input class="p-inputtext p-component"
                     type="text"
                     v-model="filters['global']"
                     placeholder="Suchen" />
            </span>
          </div>
        </template>
        <template #empty>Keine Modelle gefunden.</template>
        <template #loading>Lade alle Modelle...</template>
        <Column field="productId" header="ID" sortable>
          <template #body="slotProps">
            <a href="#" @click="viewProduct(slotProps.data)">{{
              slotProps.data.productId
            }}</a>
          </template>
        </Column>
        <div class="p-fluid p-formgrid p-grid">
          <Column field="productNameByVme" header="VME-Bez." sortable>
            <template #body="slotProps">
              <a href="#" @click="viewProduct(slotProps.data)"
                >{{
                  slotProps.data.productNameByVme !== ""
                    ? slotProps.data.productNameByVme
                    : slotProps.data.pname
                }}
              </a>
            </template>
          </Column>

          <Column
            field="productNameBySupplier"
            header="Lieferantenbez."
            sortable
          >
            <template #body="slotProps">
              <a href="#" @click="viewProduct(slotProps.data)">{{
                slotProps.data.productNameBySupplier
              }}</a>
            </template>
          </Column>

          <Column field="productNameByMerchant" header="Händlerbez." sortable>
            <template #body="slotProps">
              <a href="#" @click="viewProduct(slotProps.data)">{{
                slotProps.data.productNameByMerchant
              }}</a>
            </template>
          </Column>
          <Column header="Aktionen" v-if="isAdmin()">
            <template #body="slotProps">
              <a href="#" @click="editProduct(slotProps.data)">
                <Button
                  label="Bearbeiten"
                  icon="pi pi-pencil p-button-warning"
                />
              </a>
            </template>
          </Column>
        </div>
      </DataTable>
    </div>

    <Dialog
      header="Modell bearbeiten"
      :visible.sync="displayUpdateModal"
      :style="{ width: '50vw' }"
    >
      <div class="p-fluid">
        <div class="p-field">
          <h3>ID: {{ selectedProduct.productId }}</h3>
        </div>
        <div class="p-field">
          <label for="nameVme">Name (VME)</label>
          <input class="p-inputtext p-component"
            id="nameVme"
            v-model="selectedProduct.productNameByVme"
            type="text"
          />
        </div>
        <div class="p-field">
          <label for="nameSup">Name (Lieferant)</label>
          <input
            class="p-inputtext p-component"
            id="nameSup"
            v-model="selectedProduct.productNameBySupplier"
            type="text"
          />
        </div>
        <div class="p-field">
          <label for="nameMerch">Name (Händler)</label>
          <input class="p-inputtext p-component"
            id="nameMerch"
            v-model="selectedProduct.productNameByMerchant"
            type="text"
          />
        </div>
      </div>

      <template #footer>
        <Button
          label="Speichern"
          icon="pi pi-save"
          @click="updateProduct()"
          v-if="!isLoading"
          autofocus
        />
        <Button
          label="Schließen"
          icon="pi pi-times-circle"
          @click="displayUpdateModal = false"
          v-if="!isLoading"
          autofocus
        />

        <ProgressSpinner
          style="width: 20px; height: 20px"
          strokeWidth="8"
          fill="#EEEEEE"
          animationDuration=".5s"
          v-if="isLoading"
        />
      </template>
    </Dialog>

    <Dialog
      header="Produktdetails"
      :visible.sync="display"
      :style="{ width: '50vw' }"
    >
      <div class="p-grid">
        <div class="p-col-4">Sytem-ID: {{ selectedProduct.productId }}</div>
        <div class="p-col-4"></div>
        <div class="p-col-4 p-text-right">
          Händler-ID: 8524<br />
          Lieferanten-ID: 6943
        </div>
      </div>
      <h1>
        Modell (VME):
        {{
          selectedProduct.pname !== ""
            ? selectedProduct.pname
            : selectedProduct.productNameByVme
        }}
      </h1>
      <p class="model-name-cont">
        <b>Lieferantenbez.: </b>
        {{ selectedProduct.productNameBySupplier }}<br />
        <b>Händlerbez.: </b>
        {{ selectedProduct.productNameByMerchant }}
      </p>
      <div class="model-img-cont">
        <img :src="selectedProduct.url" alt="Modellname" />
      </div>
      <p>
        <b>Beschreibung:</b><br />
        {{ selectedProduct.description }}
      </p>
      <p>
        <b>Lieferung (KW):</b>
        {{ selectedProduct.deliveryDate }} KW + {{ agreementTime }} W =
        <span class="shipping-time">{{ shippingTime }} KW</span>
      </p>
      <p>
        <b>Hinweis:</b><br />
        Es kann zu Verzögerungen von 1 bis 2 Wochen kommen.
      </p>

      <template #footer>
        <Button
          label="Ok"
          icon="pi pi-times-circle"
          @click="display = false"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { FETCH_SUPPLIERS, FETCH_PRODUCTS, UPDATE_PRODUCT } from "../../store/actions.type"
import Menubar from "primevue/menubar"
import DataTable from "primevue/datatable"
import Column from "primevue/column"
import Dropdown from "primevue/dropdown"
import Checkbox from "primevue/checkbox"
import Dialog from "../../components/Dialog"
import Sidebar from "primevue/sidebar"
import ProgressSpinner from "primevue/progressspinner"
import "primeflex/primeflex.css"

import { mapGetters } from "vuex"
import axios from "axios"

export default {
  name: "suppliers",
  data() {
    return {
      suppliers: [],
      display: false,
      displayBasic2: false,
      selectedSupplier: null,
      freeCollection: false,
      displayUpdateModal: false,
      filters: {},
      loading: true,
      showList: false,
      representatives: null,
      isLoading: false,
      selectedProduct: {
        pname: "",
        description: "",
        price: "",
        deliveryDate: "",
      },
    }
  },
  mounted() {
    console.log(this.$msal)
  },
  methods: {
    fetchSuppliers() {
      this.$store.dispatch(FETCH_SUPPLIERS)
      if (this.$route.params.supplierId) {
        this.selectedSupplier = this.getSupplierById(this.$route.params.supplierId)
        this.updateReps()
      }
    },
    getSupplierById(id){
      let supplierItem = null
      this.allSuppliers.forEach(function(item){
        if (item.supplierId === id) {
          supplierItem = item
          return supplierItem
        }
      })
      return supplierItem
    },
    openBasic2() {
      this.displayBasic2 = true
    },
    viewProduct(product) {
      this.selectedProduct = product
      this.display = true
    },
    updateReps() {
      this.showList = true
      //this.representatives = this.repsList[this.selectedSupplier.id];
      let params = {
        supplierId: this.selectedSupplier.supplierId,
        merchantId: 1,
        isNotSpecific: !!this.freeCollection.length,
      }
      let self = this
      this.$store.dispatch(FETCH_PRODUCTS, params)
        .then((res) => {
          self.loading = false
        })
        .catch((err) => {
          console.log(err)
          self.loading = false
        })
    },
    updateProduct() {
      this.isLoading = true
      this.$store
        .dispatch(UPDATE_PRODUCT, this.selectedProduct)
        .then(() => {
          this.$toast.add({
            severity: "success",
            summary: "Success",
            detail: "Successfully updated the selected product",
            life: 3000
          })
          this.updateReps()
          this.displayUpdateModal = false
          this.isLoading = false
        })
        .catch(error => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 3000
          })
          this.isLoading = false
        })
    },
    editProduct(product) {
      this.selectedProduct = {
        _id: product._id,
        productId: product.productId,
        productNameBySupplier: product.productNameBySupplier,
        productNameByMerchant: product.productNameByMerchant,
        productNameByVme: product.productNameByVme === undefined ? product.pname : product.productNameByVme
      }
      console.log(this.selectedProduct)
      this.displayUpdateModal = true
    },
  },
  created() {
    if (!this.$msal.isAuthenticated()) {
      this.$router.push("/login")
    }
    if (this.$msal.isAuthenticated()) {
      this.fetchSuppliers()
    }
  },
  computed: {
    ...mapGetters(["allSuppliers", "allProducts"]),
    shippingTime() {

      if (!this.selectedSupplier) {
        return
      }

      let deliveryDate = this.selectedProduct.deliveryDate ? this.selectedProduct.deliveryDate : 0
      let agreementTime = 0

      if (this.selectedSupplier.hasOwnProperty("agreementTime")) {
        agreementTime = this.selectedSupplier.agreementTime === null ||
          this.selectedSupplier.agreementTime === undefined ? 0 : this.selectedSupplier.agreementTime
      }

      let shippingTime = parseInt(deliveryDate) + parseInt(agreementTime)

      return `${shippingTime}`
    },
    deliveryDate() {
      return this.selectedProduct.deliveryDate ? this.selectedProduct.deliveryDate : 0
    },
    agreementTime() {
      let agreementTime = 0

      if (!this.selectedSupplier) {
        return
      }

      if (this.selectedSupplier.hasOwnProperty("agreementTime")) {
        agreementTime = this.selectedSupplier.agreementTime === null || this.selectedSupplier.agreementTime === undefined ? 0 : this.selectedSupplier.agreementTime
      }

      return agreementTime
    }

  },
  watch: {
    allProducts(products) {
      this.representatives = products
    },
    freeCollection(val) {
      let params = {
        supplierId: this.selectedSupplier.supplierId,
        merchantId: "1",
        isNotSpecific: !!this.freeCollection.length,
      }
      this.$store.dispatch(FETCH_PRODUCTS, params)
    },
  },
  components: {
    Menubar,
    DataTable,
    Column,
    Dropdown,
    Checkbox,
    Dialog,
    ProgressSpinner
  },
};
</script>

<style lang="scss">
.shipping-time {
  font-weight: 800;
}
.model-img-cont {
  margin: 0 auto;
}

.model-img-cont img {
  max-width: 90%;
}

.p-button {
  background: #293642;
  border: 1px solid #293642;
}

.p-datatable .p-sortable-column.p-highlight {
  background: #969696;
  color: #ffffff;
}
.model-name-cont b {
  color: #333333;
}
</style>



// WEBPACK FOOTER //
// src/view/pages/Suppliers.vue